export default {
  namespased: true,
  state: {
    id: '',
    form: '',
    account_no: '',
    payment_term: '',
    agreement_date: '',
    agreement_time: '',
    agreement_city: ''
  },
  getters: {
  },
  actions: {
  },
  mutations: {

    updatePayment(state, payload){
      state[payload.obj] = payload.value
    }

  }
}